module.exports = __webpack_public_path__ + "img/camera.b9884c89.svg";